import { create } from 'zustand';

/** O SISCRED de um ano encerrou neste dia (o limite global foi atingido). */
export interface EncerramentoDoSiscred {
  readonly ano: number;
  readonly encerradoEm: Date;
}

interface EstadoDoSiscred {
  readonly encerramentos: readonly EncerramentoDoSiscred[];
  definir(encerramentos: readonly EncerramentoDoSiscred[]): void;
}

/**
 * Os SISCRED encerrados (27/10/2026), lidos uma vez ao entrar — é deles que
 * sai o ano vigente do Recorrente (`exercicioVigente`). Vazio até a leitura:
 * vale a regra de julho, que é o que o Deca sempre fez.
 */
export const usarSiscred = create<EstadoDoSiscred>((set) => ({
  encerramentos: [],
  definir: (encerramentos) => set({ encerramentos }),
}));
